/** Store PIN in client: `VITE_ADMIN_PIN`; server must accept same value (`ADMIN_DEPLOY_PIN`) — see SECRETS.md. */

/** Session flag after successful admin PIN login (must match AdminPage). */
export const ADMIN_PIN_SESSION_KEY = "jmanatx_admin_pin";

function readAdminPinFromEnv(): string {
  const raw = import.meta.env.VITE_ADMIN_PIN;
  if (typeof raw === "string" && raw.trim().length > 0) return raw.trim();
  return "";
}

/**
 * PIN for the admin UI and JSON `pin` on PUT/POST `/api/*` (must match the host’s `ADMIN_DEPLOY_PIN`).
 * Set **`VITE_ADMIN_PIN`** at **build** time (e.g. hosting env for Production) so the bundle includes the store PIN.
 */
export const ADMIN_PIN = readAdminPinFromEnv();

/**
 * Optional Bearer for `/api/*` writes — **same value** as server `SITE_STATE_WRITE_TOKEN`.
 * Set **`VITE_SITE_STATE_WRITE_TOKEN`** at build; sent only after PIN login (see `cloud-admin-sync`).
 * Still present in the JS bundle — use with **PIN** and ideally **Access** on `/admin`.
 */
function readSiteStateWriteTokenFromEnv(): string {
  const raw = import.meta.env.VITE_SITE_STATE_WRITE_TOKEN;
  if (typeof raw === "string" && raw.trim().length > 0) return raw.trim();
  return "";
}

export const SITE_STATE_WRITE_TOKEN_CLIENT = readSiteStateWriteTokenFromEnv();

/** Dispatched after admin PIN login so catalog/availability sync effects re-run. */
export const ADMIN_AUTH_EVENT = "jmanatx-admin-auth";

/** Dispatched on admin logout to cancel pending cloud PUT timers. */
export const ADMIN_LOGOUT_EVENT = "jmanatx-admin-logout";

/** Background PUT to /api/catalog or /api/availability failed (detail: { message: string }). */
export const SYNC_ERROR_EVENT = "jmanatx-sync-error";

/** Successful sync — clear error banner. */
export const SYNC_CLEARED_EVENT = "jmanatx-sync-cleared";
